import { useLocation, useNavigate } from "react-router-dom";
import { useSidebar } from "../../contexts/SidebarContext";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import NotificationsBadge from "../NotificationsBadge";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import i18n from "@/i18n";

export type sidebarLabel = {
  en: string;
  ar: string;
};

type SideBarLinkProps = {
  label: sidebarLabel;
  icon: React.ReactNode;
  href: string;
  id: number;
  linksLength: number;
  shouldShow: boolean;
};

function SideBarLink({
  label,
  icon,
  href,
  id,
  linksLength,
  shouldShow,
}: SideBarLinkProps) {
  const navigate = useNavigate();
  const { handleToggleSidebar, isShowingIconsOnly } = useSidebar();
  const pathname = useLocation().pathname;

  const orders = useSelector((state: RootState) => state.orders.newOrders);

  const handleNavigate = (link: string) => {
    handleToggleSidebar();
    navigate(link);
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobileView = screenWidth > 600;
  const shouldDisplayLink = !(id === linksLength + 1 && isMobileView);

  if (!shouldShow) return null;

  return (
    <AnimatePresence>
      {shouldDisplayLink && (
        <motion.li
          title={isShowingIconsOnly ? i18n.language === "ar" ? label.ar : label.en as string : ""}
          onClick={() => handleNavigate(href)}
          className={`group flex cursor-pointer items-center justify-between rounded-lg py-3 text-[0.9rem] text-base font-semibold capitalize hover:bg-skyblue hover:text-sidebar ${pathname.includes(href) ? "bg-skyblue text-sidebar" : "text-skyblue"} relative duration-200 ${isShowingIconsOnly ? "w-fit px-3" : "w-full ps-3"}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <span className="flex items-center justify-start gap-3">
            {icon}
            <AnimatePresence>
              {!isShowingIconsOnly && (
                <motion.span
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  // exit={{ opacity: 0, x: -10 }}
                  transition={{ duration: 0.4 }}
                >
                  {i18n.language === "ar" ? label.ar : label.en}
                </motion.span>
              )}
            </AnimatePresence>
          </span>
          {/* orders.length > 0 && */}
          {label.en === "orders" && orders.length > 0 && (
            <NotificationsBadge
              xAxis="end"
              position={`${isShowingIconsOnly ? "absolute" : "relative"}`}
              relativeClassNames={` me-3 mt-[2px]`}
              parentClassNames={` ${isShowingIconsOnly ? "!end-[-2px] !top-[-2px] !bg-red-500 !text-white " : `${pathname.includes(href) ? "bg-sidebar !text-skyblue" : "!text-sidebar bg-skyblue group-hover:bg-sidebar group-hover:!text-skyblue"}`}  `}
              childClassNames={`  ${isShowingIconsOnly ? "!end-[-2px] !top-[-2px] !bg-red-500 !text-white " : `${pathname.includes(href) ? "bg-sidebar !text-skyblue" : "!text-sidebar bg-skyblue group-hover:bg-sidebar group-hover:!text-skyblue"}`} `}
              length={orders.length}
            />
          )}
        </motion.li>
      )}
    </AnimatePresence>
  );
}

export default SideBarLink;
